import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import * as Constants from "../../../../constants/Constants";
import * as Helpers from "../../../../global/Helpers";
import * as utils from "../../../../global/utils";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../../SessionExpiredPOPup/SessionExpiredPOPup";
import { Redirect } from "react-router-dom";

const FatcaCRSDeclaration = (props) => {
  const [address, setSelectedaddress] = useState("");
  const [redirect, setRedirect] = useState(null);
  const [sourceOfIncome, setSourceOfIncome] = useState([]);
  const [AnnualIncome, setAnnualIncome] = useState([]);

  const { t } = useTranslation();
  const [hasPreviousOccupation, setHasPreviousOccupation] = useState(false);

  const [formState, setFormState] = useState({
    dropdown1: "",
    dropdown2: "",
    dropdown3: "",
    dropdown4: "",
    dropdown5: "",
  });

  useEffect(() => {
    fetchSourceOfIncome();
    fetchAnnualIncome();
  }, [i18next.language]);

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (formState.dropdown1 === "") {
      Helpers.errorNotify(t("Please fill Source of Income"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (formState.dropdown2 === "") {
      Helpers.errorNotify(t("Please fill Industry"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (address === "") {
      Helpers.errorNotify(t("Please fill Current employer name"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (formState.dropdown3 === "") {
      Helpers.errorNotify(t("Please fill Annual Income"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (formState.dropdown4 === "") {
      Helpers.errorNotify(t("Please fill  Value of Net Assets"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (formState.dropdown5 === "") {
      Helpers.errorNotify(t("Please fill Regular financial"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }

    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;

        var result = Helpers.getScreenIdByGroupAndName("financial status screen");
    
    var Items = [
      { ID: "23", Value: formState.dropdown1 },
      { ID: "19", Value: formState.dropdown2 },
      { ID: "20", Value: address },
      // { ID: "21", Value: address },
      { ID: "137", Value: formState.dropdown3 },
      // { ID: "24", Value: formState.dropdown3 },
      { ID: "93", Value: formState.dropdown4 },
      { ID: "237", Value: formState.dropdown5 },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    props.saveKycDataAPI(Items);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSwitchChange = (event) => {
    setHasPreviousOccupation(event.target.checked);
  };
  const handleAddreddChange = (event) => {
    setSelectedaddress(event.target.value);
  };

  const fetchSourceOfIncome = async () => {
    try {
      const data = { FormType: "1", Lang: i18next.language === "ar" ? "AR" : "EN" };
      var response = utils.CallKYCAPI(Constants.GetSourceOfIncome, data);
      await response
        .then((response) => {
          if (response.data.ErrorMsg === "success") {
            setSourceOfIncome(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />;
              },
            });
          } else {
            setSourceOfIncome([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("setSourceOfIncome", error);
        });
    } catch (error) {
      console.error("Error posting data setSourceOfIncome:", error);
    }
  };
  const fetchAnnualIncome = async () => {
    try {
      const data = { FormType: "1", Lang: i18next.language === "ar" ? "AR" : "EN" };
      var response = utils.CallKYCAPI(Constants.GetAnnualIncome, data);
      await response
        .then((response) => {
          if (response.data.ErrorMsg === "success") {
            setAnnualIncome(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />;
              },
            });
          } else {
            setAnnualIncome([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("GetAnnualIncome", error);
        });
    } catch (error) {
      console.error("Error posting data GetAnnualIncome:", error);
    }
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="seekbar-wrapper  financialStatusDiv">
            <div className="form-group ">
              <h5>{t("learnaboutyourfinancialstatus")}</h5>
              <label htmlFor="dropdown1" className="form-label">
                {t("SourceofIncome")}
              </label>
              <select id="dropdown1" name="dropdown1" value={formState.dropdown1} onChange={handleChange} className="form-select">
                <option value="" disabled>
                  {t("PleaseSelect")}
                </option>

                {sourceOfIncome.map((obj) => {
                  return <option value={obj.value}>{obj.SourceOfIncome}</option>;
                })}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="dropdown2" className="form-label">
                {t("Industry")}
              </label>
              <select id="dropdown2" name="dropdown2" value={formState.dropdown2} onChange={handleChange} className="form-select">
                <option value="" disabled>
                  {t("PleaseSelect")}
                </option>
                <option value="1">FINANCIAL SERVICES</option>
                <option value="2">CONSUMER & INDUSTRIAL PRODUCTS</option>
                <option value="3">CONSTRUCTION</option>
                <option value="4">MEDIA & COMMUNICATIONS</option>
                <option value="5">NON-PROFIT ORGANIZATIONS</option>
                <option value="6">PUBLIC SECTOR</option>
                <option value="7">EDUCATION</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="dropdown3" className="form-label">
                {t("Currentemployername")}
              </label>
              <input id="textAd" name="address" type="text" value={address} onChange={handleAddreddChange} className="form-select" />
            </div>
            <div className="form-group">
              <label htmlFor="dropdown3" className="form-label">
                {t("AnnualIncome")}
              </label>
              <div style={{ display: "flex" }}>
                <label htmlFor="dropdown3" className="form-label-CurrCode">
                  {t("AED")}
                </label>
                <select id="dropdown3" name="dropdown3" value={formState.dropdown3} onChange={handleChange} className="form-select dropdown3">
                  <option value="" disabled>
                    {t("PleaseSelect")}
                  </option>
                  {AnnualIncome.map((obj) => {
                    return <option value={obj.value}>{obj.SourceOfIncome}</option>;
                  })}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown4" className="form-label">
                {t("ValueofNetAssets")}
              </label>
              <div style={{ display: "flex" }}>
                <label htmlFor="dropdown3" className="form-label-CurrCode">
                  {t("AED")}
                </label>
                <select id="dropdown4" name="dropdown4" value={formState.dropdown4} onChange={handleChange} className="form-select dropdown4">
                  <option value="" disabled>
                    {t("PleaseSelect")}
                  </option>
                  <option value="1">100,000</option>
                  <option value="2">200,000</option>
                  <option value="3">300,000</option>
                  <option value="4">400,000</option>
                  <option value="5">500,000</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown5" className="form-label">
                {t("Regularfinancial")}
              </label>
              <div style={{ display: "flex" }}>
                <label htmlFor="dropdown3" className="form-label-CurrCode">
                  {t("AED")}
                </label>
                <select id="dropdown5" name="dropdown5" value={formState.dropdown5} onChange={handleChange} className="form-select dropdown5">
                  <option value="" disabled>
                    {t("PleaseSelect")}
                  </option>
                  <option value="1">{"None"}</option>
                  <option value="2">{"<25%"}</option>
                  <option value="3">{"25%-50%"}</option>
                  <option value="4">{">50%"} </option>
                </select>
              </div>
            </div>
            <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
              <label htmlFor="dropdown5" className="form-label">
                {t("PreviousOccupation")}
              </label>
              <div className="switch-container">
                <label className="switch">
                  <input type="checkbox" checked={hasPreviousOccupation} onChange={handleSwitchChange} />
                  <span className="slider"></span>
                </label>
                {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
              </div>
            </div>
          </div>

          {/* <button type="submit" className="submit-button">Submit</button> */}
        </form>
      </div>
    </div>
  );
};

export default FatcaCRSDeclaration;
